import React, { useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/Header.css";
import "../style/Navbar.css";

const Navbar = ({ currentLanguage, onLanguageChange }) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const navLinks = {
    EN: {
      home: "Home",
      services: "Services",
      fleet: "Fleet",
      rates: "Rates",
      contact: "Contact Us",
      testimonials: "Testimonials",
      bookNow: "Book Now",
    },
    AR: {
      home: "الرئيسية",
      services: "الخدمات",
      fleet: "الأسطول",
      rates: "الأسعار",
      contact: "تواصل معنا",
      testimonials: "الشهادات",
      bookNow: "احجز الآن",
    },
    ES: {
      home: "Inicio",
      services: "Servicios",
      fleet: "Flota",
      rates: "Tarifas",
      contact: "Contáctenos",
      testimonials: "Testimonios",
      bookNow: "Reservar Ahora",
    },
  };

  const translations = navLinks[currentLanguage];

  const toggleNavbar = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  const closeNavbar = () => {
    if (!isNavCollapsed) {
      setIsNavCollapsed(true);
    }
  };

  const handleLanguageChange = (language) => {
    onLanguageChange(language);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark modern-navbar py-3">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center modern-brand" to="/">
          <div className="logo-container">
            <img
              src="/images/logo.png"
              alt="Gators Transportation Logo"
              className="logo"
            />
          </div>
          <span className="brand-text text-uppercase fw-bold ms-3">
            Gators Transportation <span style={{ fontSize: '0.7em', fontWeight: 'normal' }}>Inc.</span>
          </span>
        </Link>

        {/* Toggle button for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed ? "true" : "false"}
          aria-label="Toggle navigation"
          onClick={toggleNavbar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar links */}
        <div
          className={`collapse navbar-collapse ${isNavCollapsed ? "" : "show"}`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto modern-nav">
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/"
                onClick={closeNavbar}
              >
                {translations.home}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/services"
                onClick={closeNavbar}
              >
                {translations.services}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/fleet"
                onClick={closeNavbar}
              >
                {translations.fleet}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/rates"
                onClick={closeNavbar}
              >
                {translations.rates}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/contact"
                onClick={closeNavbar}
              >
                {translations.contact}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link modern-nav-link text-uppercase"
                to="/testimonials"
                onClick={closeNavbar}
              >
                {translations.testimonials}
              </Link>
            </li>
          </ul>

          {/* Desktop: Right side buttons */}
          <div className="d-none d-lg-flex align-items-center">
            <Link
              className="btn btn-success text-uppercase fw-bold blinking me-3 btn-size modern-btn"
              to="/ReservationForm"
            >
              {translations.bookNow}
            </Link>

            {/* Language Dropdown */}
            <div className="dropdown modern-dropdown">
              <button
                className="btn btn-outline-light dropdown-toggle modern-lang-btn"
                type="button"
                id="languageDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={`/images/${
                    currentLanguage === "EN"
                      ? "us.ico"
                      : currentLanguage === "AR"
                      ? "sa.ico"
                      : "spain.ico"
                  }`}
                  alt={currentLanguage}
                  className="lang-icon me-2"
                />
                {currentLanguage}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end modern-dropdown-menu"
                aria-labelledby="languageDropdown"
              >
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center modern-dropdown-item"
                    onClick={() => handleLanguageChange("EN")}
                  >
                    <img
                      src="/images/us.ico"
                      alt="English"
                      className="dropdown-lang-icon me-2"
                    />
                    English
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center modern-dropdown-item"
                    onClick={() => handleLanguageChange("AR")}
                  >
                    <img
                      src="/images/sa.ico"
                      alt="Arabic"
                      className="dropdown-lang-icon me-2"
                    />
                    Arabic
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center modern-dropdown-item"
                    onClick={() => handleLanguageChange("ES")}
                  >
                    <img
                      src="/images/spain.ico"
                      alt="Spanish"
                      className="dropdown-lang-icon me-2"
                    />
                    Spanish
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Mobile: Book Now and Language inside collapsed menu */}
          <div className="d-lg-none mt-3 border-top pt-3">
            <div className="d-flex flex-column gap-3">
              <Link
                className="btn btn-success text-uppercase fw-bold modern-btn mobile-book-btn"
                to="/ReservationForm"
                onClick={closeNavbar}
              >
                {translations.bookNow}
              </Link>
              
              {/* Mobile Language Selector */}
              <div className="mobile-lang-selector">
                <h6 className="text-white mb-2">Language / اللغة / Idioma</h6>
                <div className="d-flex gap-2">
                  <button
                    className={`btn btn-sm ${currentLanguage === 'EN' ? 'btn-primary' : 'btn-outline-light'} mobile-lang-btn`}
                    onClick={() => handleLanguageChange("EN")}
                  >
                    <img src="/images/us.ico" alt="English" className="mobile-lang-icon me-1" />
                    EN
                  </button>
                  <button
                    className={`btn btn-sm ${currentLanguage === 'AR' ? 'btn-primary' : 'btn-outline-light'} mobile-lang-btn`}
                    onClick={() => handleLanguageChange("AR")}
                  >
                    <img src="/images/sa.ico" alt="Arabic" className="mobile-lang-icon me-1" />
                    AR
                  </button>
                  <button
                    className={`btn btn-sm ${currentLanguage === 'ES' ? 'btn-primary' : 'btn-outline-light'} mobile-lang-btn`}
                    onClick={() => handleLanguageChange("ES")}
                  >
                    <img src="/images/spain.ico" alt="Spanish" className="mobile-lang-icon me-1" />
                    ES
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
